import { KOMCOL, MINCOL } from '../../../constants/const';
import DropdownFilter from '../SD_einsehen/DropdownFilter';

export const vlpHeader = [
    {
        accessor: 'vv',
        Header: 'Verkehrsvertrag',
        width: KOMCOL,
        Filter: DropdownFilter
    },
    {
        accessor: 'linie',
        Header: 'Linie',
        width: MINCOL,
        Filter: DropdownFilter
    },
    {
        accessor: 'produkt',
        Header: 'Produkt',
        width: MINCOL
    },
    {
        accessor: 'gueltigVon',
        Header: 'Gültigkeitsbeginn',
        width: MINCOL
    },
    {
        accessor: 'gueltigBis',
        Header: 'Gültigkeitsende',
        width: MINCOL
    }
];

export const vlpHidden = ['vlpId', 'vvId', 'linieId', 'prodId']

export const csvHeaderVvlp = [
    'Verkehrsvertrag',
    'Linie',
    'Produkt',
    'Gültigkeitsbeginn',
    'Gültigkeitsende',
    'Kommentar'
];
